module.exports = __webpack_public_path__ + "img/tree2.cbad1f19.png";